var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "b-form-group",
    {
      attrs: {
        id: "fontSize",
        horizontal: "",
        "label-cols": "3",
        "label-size": "md",
        label: _vm.$t("labels.fontSize") + ":"
      }
    },
    [
      _c(
        "b-row",
        [
          _c("b-col", { attrs: { lg: "5" } }, [
            _c(
              "label",
              { staticClass: "customi_label", attrs: { for: "Compact" } },
              [
                _c("input", {
                  directives: [
                    {
                      name: "model",
                      rawName: "v-model",
                      value: _vm.size,
                      expression: "size"
                    }
                  ],
                  staticClass: "invisible customi_input",
                  attrs: {
                    type: "radio",
                    id: "Compact",
                    name: "size",
                    value: "Compact"
                  },
                  domProps: { checked: _vm._q(_vm.size, "Compact") },
                  on: {
                    change: function($event) {
                      _vm.size = "Compact"
                    }
                  }
                }),
                _vm._v(" "),
                _c("div", { staticClass: "customi_div radio" }, [
                  _c(
                    "svg",
                    {
                      staticClass: "customi_svg",
                      attrs: {
                        version: "1.1",
                        id: "Layer_1",
                        viewBox: "0 0 20 20"
                      }
                    },
                    [
                      _c("circle", {
                        staticClass: "svg_bg",
                        attrs: { cx: "10", cy: "10", r: "9" }
                      }),
                      _vm._v(" "),
                      _c("circle", {
                        staticClass: "svg_top radio_check",
                        attrs: { cx: "10", cy: "10", r: "6" }
                      })
                    ]
                  )
                ]),
                _vm._v(" "),
                _c("span", [_vm._v(_vm._s(_vm.$t("labels.compact")))])
              ]
            )
          ]),
          _vm._v(" "),
          _c("b-col", { attrs: { lg: "5" } }, [
            _c(
              "label",
              { staticClass: "customi_label", attrs: { for: "Big" } },
              [
                _c("input", {
                  directives: [
                    {
                      name: "model",
                      rawName: "v-model",
                      value: _vm.size,
                      expression: "size"
                    }
                  ],
                  staticClass: "invisible customi_input",
                  attrs: {
                    type: "radio",
                    id: "Big",
                    name: "size",
                    value: "Big"
                  },
                  domProps: { checked: _vm._q(_vm.size, "Big") },
                  on: {
                    change: function($event) {
                      _vm.size = "Big"
                    }
                  }
                }),
                _vm._v(" "),
                _c("div", { staticClass: "customi_div radio" }, [
                  _c(
                    "svg",
                    {
                      staticClass: "customi_svg",
                      attrs: {
                        version: "1.1",
                        id: "Layer_1",
                        viewBox: "0 0 20 20"
                      }
                    },
                    [
                      _c("circle", {
                        staticClass: "svg_bg",
                        attrs: { cx: "10", cy: "10", r: "9" }
                      }),
                      _vm._v(" "),
                      _c("circle", {
                        staticClass: "svg_top radio_check",
                        attrs: { cx: "10", cy: "10", r: "6" }
                      })
                    ]
                  )
                ]),
                _vm._v(" "),
                _c("span", [_vm._v(_vm._s(_vm.$t("labels.big")))])
              ]
            )
          ])
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/vue-loader/lib??vue-loader-options!./src/components/Pages/Settings/fontSize.vue?vue&type=template&id=dec7ad9e&
// module id = null
// module chunks = 